import type { LoginCredentials } from '@mathflat/domain/Auth'

type LoginErrorField = {
  field: keyof Pick<LoginCredentials, 'id' | 'password'>
  message: string
}

const ID_CHECK_MESSAGE = '아이디를 다시 확인해주세요.'

const LOGIN_ERROR_FIELD = new Map<string, LoginErrorField>([
  ['USER_NOT_FOUND', { field: 'id', message: ID_CHECK_MESSAGE }],
  /** 퇴원 학생·자녀가 모두 퇴원한 학부모 — 계정이 있다는 사실을 드러내지 않도록 없는 아이디와 같은 얼굴로 막는다 */
  ['UNAUTHORIZED', { field: 'id', message: ID_CHECK_MESSAGE }],
  ['USER_WRONG_PASSWORD', { field: 'password', message: '비밀번호를 다시 확인해주세요.' }],
  ['USER_EXPIRED', { field: 'id', message: '현재 유저는 사용중지되었습니다.' }],
])

export const getLoginErrorField = (code: string | undefined): LoginErrorField | undefined =>
  code ? LOGIN_ERROR_FIELD.get(code) : undefined
